
import { defineComponent, computed, ref } from 'vue'

export default defineComponent({
  name: 'Card',
  emits: ['card-clicked'],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ''
    },
    linkHref: {
      type: String,
      default: null
    },
    linkAction: {
      type: Function
    }
  },
  setup(props) {
    const isMenuOpen = ref(false)
    function toggleMenu(val: boolean) {
      isMenuOpen.value = val
    }

    const backgroundImage = computed(() => {
      return `background-image: url('${props.imageUrl}')`
    })

    return {
      backgroundImage,
      toggleMenu,
      isMenuOpen
    }
  }
})
